export const INPATIENT = 'Inpatient';
export const DISCHARGED_AS_INPT = 'Discharged as INPT';
